import axios from 'axios'

export default {
  getChangeLog (callback, errorCallback) {
    // Create a new axios instance to override default interceptors that add auth headers
    const _axios = axios.create()
    _axios.get(process.env.ROOT_STATIC + '/static/api/CHANGELOG.md',
      {
        headers: {
          // See https://tools.ietf.org/html/rfc7763
          'Content-Type': 'text/markdown'
        }
      })
      .then((response) => {
        callback(response.data)
      })
      .catch((error) => {
        errorCallback(error.response.data)
      })
  },
  getTokens (callback, errorCallback) {
    axios.get(process.env.ROOT_API + '/tokens/')
      .then((response) => {
        callback(response.data)
      })
      .catch((error) => {
        errorCallback(error.response.data)
      })
  },
  createToken (callback, errorCallback) {
    axios.post(process.env.ROOT_API + '/tokens/')
      .then((response) => {
        callback(response.data)
      })
      .catch((error) => {
        errorCallback(error.response.data)
      })
  },
  getCountries (callback, errorCallback) {
    axios.get(process.env.ROOT_API + '/countries/platform/')
      .then((response) => {
        callback(response.data)
      })
      .catch((error) => {
        errorCallback(error.response.data)
      })
  },
  getUserProfile (callback, errorCallback) {
    axios.get(process.env.ROOT_API + '/me/')
      .then((response) => {
        callback(response.data)
      })
      .catch((error) => {
        errorCallback(error.response.data)
      })
  },
  updateUserProfile (params, callback, errorCallback) {
    console.log(params)
    axios.patch(process.env.ROOT_API + '/me/', params)
      .then((response) => {
        callback(response.data)
      })
      .catch((error) => {
        errorCallback(error.response.data)
      })
  },
  getNotifications (callback, errorCallback) {
    axios.get(process.env.ROOT_API + '/notifications/')
      .then((response) => {
        callback(response.data)
      })
      .catch((error) => {
        errorCallback(error.response.data)
      })
  }
}



// WEBPACK FOOTER //
// ./src/api/home.js